import { IEquatable } from "../IEquatable";

export interface IDRCXAvailableObjectBase<TKeyType> extends IEquatable<TKeyType> {
    displayText: string;
    equatableKey: TKeyType;
}

export abstract class DRCXAvailableObjectBase<TKeyType> implements IDRCXAvailableObjectBase<TKeyType> {
    public constructor(
        public displayText: string,
        public equatableKey: TKeyType,
    ) {
    }
}
